export const declOfNumber = (number_: number, titles: string[]): string => {
  // eslint-disable-next-line @typescript-eslint/no-extra-parens
  return titles[(number_ % 10 === 1 && number_ % 100 !== 11) ? 0 : (number_ % 10 >= 2 && number_ % 10 <= 4 && (number_ % 100 < 10 || number_ % 100 >= 20) ? 1 : 2)]
}

export const numberSpaces = (number_: number | string): string => {
  // eslint-disable-next-line require-unicode-regexp,unicorn/no-unsafe-regex
  return number_.toString().replaceAll(/\B(?=(?:\d{3})+(?!\d))/g, ' ')
}
